import axios from "axios";
import { baseUrl } from "../../../../Redux/App/app.actions";

export const uploadDataReadyFileApi = async (file) => {
  try {
    const formdata = new FormData();
    formdata.append("data", file);
    const response = await axios.post(
      `${baseUrl}/b1/upload_data_ready`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log(response);
  } catch (error) {
    console.log(error);
  }
};
